import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import { COMPANY_STATUS_OPTIONS } from "../constants";
import {
  ALL_STAFF_ROLES,
  ALL_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

export const companyLocationFields = defineFieldConfigMap({
    // FIELD: address
    address: {
      type: "text",
      label: "Address",
      mobileDetailSectionId: "location",
      sortable: true,
      filterable: true,
      searchable: true,
      resizable: true,
      hideable: true,
      editable: true,
      formSpan: 3,
      filterType: "contains",
      width: 200,
      minWidth: 150,
      maxWidth: 300,
      placeholder: "123 Main St",
      icon: "MapPin",
      allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
      graphqlSelector: "address",
    },
    // FIELD: city
    city: {
      type: "text",
      label: "City",
      mobileDetailSectionId: "location",
      sortable: true,
      filterable: true,
      searchable: true,
      resizable: true,
      hideable: true,
      editable: true,
      formSpan: 1,
      filterType: "contains",
      width: 120,
      minWidth: 100,
      maxWidth: 150,
      placeholder: "City",
      icon: "MapPin",
      allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
      graphqlSelector: "city",
    },
    // FIELD: state
    state: {
      type: "text",
      label: "State",
      mobileDetailSectionId: "location",
      sortable: true,
      filterable: true,
      searchable: true,
      formSpan: 1,
      resizable: true,
      hideable: true,
      editable: true,
      filterType: "contains",
      width: 80,
      minWidth: 60,
      maxWidth: 100,
      placeholder: "ST",
      icon: "MapPin",
      allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
      graphqlSelector: "state",
    },
    // FIELD: zip_code
    zip_code: {
      type: "text",
      label: "ZIP Code",
      mobileDetailSectionId: "location",
      sortable: true,
      filterable: true,
      searchable: true,
      resizable: true,
      hideable: true,
      editable: true,
      formSpan: 1,
      filterType: "contains",
      width: 100,
      minWidth: 80,
      maxWidth: 120,
      placeholder: "12345",
      icon: "MapPin",
      allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
      graphqlSelector: "zip_code",
    },
    // FIELD: country
    country: {
      type: "text",
      label: "Country",
      mobileDetailSectionId: "location",
      sortable: true,
      filterable: true,
      searchable: true,
      resizable: true,
      hideable: true,
      editable: true,
      formSpan: 1,
      filterType: "contains",
      width: 120,
      minWidth: 100,
      maxWidth: 150,
      placeholder: "Country",
      icon: "Globe",
      allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
      graphqlSelector: "country",
    }
});
